import script from "./qrcode.vue?vue&type=script&setup=true&lang=js"
export * from "./qrcode.vue?vue&type=script&setup=true&lang=js"

import "./qrcode.vue?vue&type=style&index=0&id=265505fa&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265505fa"]])

export default __exports__